import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { environments } from 'environments/environments';

import NewsList from './NewsList/NewsList';
import SingleNewsFull from './SingleNewsFull/SingleNewsFull';

const newsSection = () => {
  document.title = environments.pageTitle + ' - Novinky';

  return (
    <div>
      <Switch>
        <Route path="/" exact component={NewsList} />
        <Route path="/novinky" exact component={NewsList} />
        <Route path="/novinky/:id" component={SingleNewsFull} />
      </Switch>
    </div>
  );
}

export default newsSection;